import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { PaymentData } from 'src/app/modules/shared/models/payment.model';
import { PaymentService } from 'src/app/modules/shared/services/payment.service';

@Component({
  selector: 'app-gift-form',
  templateUrl: './gift-form.component.html',
  styleUrls: ['./gift-form.component.scss'],
})
export class GiftFormComponent implements OnInit {
  giftForm: FormGroup;
  paymentData: PaymentData;
  constructor(
    private paymentService: PaymentService,
    private router: Router,
    private _bottomSheetRef: MatBottomSheetRef<GiftFormComponent>
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.paymentData = this.paymentService.paymentData;
  }

  private getInfo(field: string) {
    return this.giftForm.get(field).value;
  }

  initForm() {
    this.giftForm = new FormGroup({
      email: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      note: new FormControl(''),
    });
  }

  submitGift() {
    if (!this.paymentData.order.basePrice) return;

    const deliveryInfo = {
      email: this.getInfo('email'),
      giftInfo: {
        name: this.getInfo('name'),
        note: this.getInfo('note'),
      },
    };
    this.paymentService.setPaymentData({
      ...this.paymentData,
      deliveryInfo,
      isValid: true,
    });
    this.router
      .navigate(['/checkout'])
      .then(() => this._bottomSheetRef.dismiss());
  }
}
